import React from "react";
import StoreForm from "../Storeform";

const AddStore = () => {
  return <StoreForm title="Adicionar loja" network={false} />;
};

export default AddStore;
